import { api } from '@/api/index'

const state = {}

const mutations = {
  RESET(state) {
    for (const key in state) {
      state[key] = null
    }
    state = {}
  },
  UPDATE: (state, data) => {
    state[data.field] = data.data
  },
}

const actions = {
  // 用户
  cookie({ commit, state }, update = false) {
    const data = state.cookie
    return new Promise((resolve, reject) => {
      if (data && !update) {
        resolve(data)
      } else {
        api
          .get('auth/cookieData')
          .then(res => {
            let resData = res.cookie || {}
            commit('UPDATE', { field: 'cookie', data: resData })
            resolve(resData)
          })
          .catch(err => {
            resolve([])
          })
      }
    })
  },
  // 权限
  auth({ commit, state }, update = false) {
    const data = state.auth
    return new Promise((resolve, reject) => {
      if (data && !update) {
        resolve(data)
      } else {
        api
          .get('auth/authData')
          .then(res => {
            let resData = res.auth || {}
            commit('UPDATE', { field: 'auth', data: resData })
            resolve(resData)
          })
          .catch(err => {
            resolve([])
          })
      }
    })
  },
  // 权限
  code({ commit, state }, data, value) {
    return new Promise((resolve, reject) => {
      this.dispatch('user/auth')
        .then(res => {
          let result = false
          for (const key in res) {
            if (key == data[0]) {
              result = true
            } else {
              if (key.indexOf(data[0]) >= 0) {
                if (key.split(':').includes(data[1])) {
                  result = true
                }
              }
            }
          }
          resolve(result)
        })
        .catch(err => {
          resolve(false)
        })
    })
  },
  // 重置
  reset({ commit, state }) {
    commit('RESET')
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
